import { createApp } from "vue";
import { createPinia } from 'pinia'
import App from './App.vue'

import Emitter from 'tiny-emitter'

const pinia = createPinia();
const app = createApp(App);

app.use(pinia)

app.config.globalProperties.$bus = new Emitter() 

app.mount("#app");
